import React from "react";

import { isValidDate } from "utils/dates";

const NotificationDate = ({ children, ...props }) => {
  const dateObject = new Date(children);

  if (!isValidDate(dateObject)) {
    return <span {...props}>N/A</span>;
  }

  const month = dateObject.toLocaleDateString("en-US", { month: "short" });
  const date = dateObject.getDate();

  return (
    <span {...props}>
      <div>{month}</div>
      <div>{date}</div>
    </span>
  );
};

export default NotificationDate;
